import { IDefaultPreOwned, IPreOwnedContent } from '../../types';

export const getPriceBySlug = (
  slug: string,
  content: IDefaultPreOwned['content'] | IPreOwnedContent
): number => {
  if (slug === '/us') {
    return Number(content.price_USD) || Number(content.price) || 0;
  }

  return Number(content.price) || 0;
};
